import { render } from "./IconSlide.vue?vue&type=template&id=10b2dc2d&lang=html"
import script from "./IconSlide.vue?vue&type=script&lang=js"
export * from "./IconSlide.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__